module.exports = __webpack_public_path__ + "static/media/Kay W.53fbdd3e.png";